import TopBar from "./TopBar";
import "./LandingPage.css";
import { Link } from "react-router-dom";

function LandingPage() {
  return (
    <div className="landing-container">
      <TopBar />

      <div className="landing-content">
        {/* Hero Section */}
        <div className="hero-section">
          <div className="hero-content">
            <h1 className="hero-title">
              Unlock Your <span className="brand-accent">Potential</span> with TeachMeGo
            </h1>
            <p className="hero-subtitle">
              Get instant access to tutors for university and high-school subjects.  
              Now launched at UCT — expanding to more universities soon.
            </p>

            <div className="hero-stats">
              <div className="stat">
                <div className="stat-number">30+</div>
                <div className="stat-label">Active Tutors</div>
              </div>
              <div className="stat">
                <div className="stat-number">300+</div>
                <div className="stat-label">Students Supported</div>
              </div>
              <div className="stat">
                <div className="stat-number">4.9⭐</div>
                <div className="stat-label">Average Rating</div>
              </div>
            </div>

            <Link to="/auth" className="landing-cta">
              Find a Tutor
            </Link>

            
          </div>

          <div className="hero-image">
            <div className="floating-card card-1">
              <div className="card-avatar">📘</div>
              <div className="card-text">"TeachMeGo helped me understand first-year calculus!"</div>
            </div>
            <div className="floating-card card-2">
              <div className="card-avatar">👨‍🏫</div>
              <div className="card-text">"Physics tutors available today"</div>
            </div>
            <div className="floating-card card-3">
              <div className="card-avatar">⭐</div>
              <div className="card-text">"Trusted by UCT students"</div>
            </div>

            <div className="main-hero-image">
              <img
                src="https://images.unsplash.com/photo-1522202176988-66273c2fd55f?auto=format&fit=crop&w=1000&q=80"
                alt="Students learning"
                className="hero-img"
              />
            </div>
          </div>
        </div>

        {/* Features Section */}
        <div className="features-section">
          <h2 className="section-title">Why Choose TeachMeGo?</h2>
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-image">
                <img
                  src="https://images.unsplash.com/photo-1584697964358-3e14ca57658b?auto=format&fit=crop&w=500&q=80"
                  alt="Matching"
                />
              </div>
              <div className="feature-content">
                <div className="feature-icon">🎯</div>
                <h3>Smart Matching</h3>
                <p>Find tutors who understand your course, your level, and your pace.</p>
                <ul className="feature-list">
                  <li>UCT-verified tutors</li>
                  <li>Course-specific matching</li>
                  <li>High-school & university</li>
                </ul>
              </div>
            </div>

            <div className="feature-card">
              <div className="feature-image">
                <img
                  src="https://images.unsplash.com/photo-1577896851231-70ef18881754?auto=format&fit=crop&w=500&q=80"
                  alt="Flexible"
                />
              </div>
              <div className="feature-content">
                <div className="feature-icon">💻</div>
                <h3>Flexible Learning</h3>
                <p>Choose online or face-to-face sessions depending on what works for you.</p>
                <ul className="feature-list">
                  <li>Online sessions (WebRTC)</li>
                  <li>In-person at UCT</li>
                  <li>High-school options</li>
                </ul>
              </div>
            </div>

            <div className="feature-card">
              <div className="feature-image">
                <img
                  src="https://images.unsplash.com/photo-1551288049-bebda4e38f71?auto=format&fit=crop&w=500&q=80"
                  alt="Instant"
                />
              </div>
              <div className="feature-content">
                <div className="feature-icon">⚡</div>
                <h3>Instant Booking</h3>
                <p>Request a session and get matched with an available tutor in real time.</p>
                <ul className="feature-list">
                  <li>Instant session requests</li>
                  <li>Clear pricing per tutor</li>
                  <li>Secure in-app wallet</li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* Subjects Section */}
        <div className="subjects-section">
          <h2 className="section-title">Available Subjects</h2>
          <div className="subjects-grid">
            <div className="subject-card math">
              <div className="subject-icon">📊</div>
              <h3>UCT Mathematics</h3>
              <p>1st – 3rd Year Courses</p>
            </div>

            <div className="subject-card science">
              <div className="subject-icon">🔬</div>
              <h3>UCT Physics</h3>
              <p>1st – 2nd Year</p>
            </div>

            <div className="subject-card stats">
              <div className="subject-icon">📈</div>
              <h3>UCT Statistics</h3>
              <p>1st – 2nd Year</p>
            </div>

            <div className="subject-card highschool">
              <div className="subject-icon">🎓</div>
              <h3>High-School Support</h3>
              <p>Maths & Physical Sciences</p>
            </div>
          </div>

          <p className="subjects-footer">
            Want your university to be added?  
            Email us at <strong>teachmego01@gmail.com</strong>.
          </p>
        </div>

        {/* Testimonials */}
        <div className="testimonials-section">
          <h2 className="section-title">Student Stories</h2>
          <div className="testimonials-grid">
            <div className="testimonial-card">
              <div className="testimonial-content">
                "I finally understood MAM1000W because of TeachMeGo. Their tutors actually know UCT content!"
              </div>
              <div className="testimonial-author">
                <div className="author-avatar">👩‍🎓</div>
                <div className="author-info">
                  <div className="author-name">Anele M.</div>
                  <div className="author-course">UCT BSc Student</div>
                </div>
              </div>
            </div>

            <div className="testimonial-card">
              <div className="testimonial-content">
                "The real-time booking saved me before my PHY1023H test. Highly recommend."
              </div>
              <div className="testimonial-author">
                <div className="author-avatar">⚛️</div>
                <div className="author-info">
                  <div className="author-name">Thabo S.</div>
                  <div className="author-course">Physics Student</div>
                </div>
              </div>
            </div>

            <div className="testimonial-card">
              <div className="testimonial-content">
                "Great platform! I applied as a tutor and started getting students within a week."
              </div>
              <div className="testimonial-author">
                <div className="author-avatar">👨‍🏫</div>
                <div className="author-info">
                  <div className="author-name">Melissa K.</div>
                  <div className="author-course">TeachMeGo Tutor</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Final CTA */}
        <div className="final-cta">
          <h2>Ready to Transform Your Learning?</h2>
          <p>Join students and tutors shaping the future of education.</p>
          <Link to="/auth" className="cta-secondary">
            Get Started — It's Free
          </Link>
        </div>
      </div>

      {/* Footer */}
<footer className="footer">
  <div className="footer-content">
    <div className="footer-section">
      <div className="footer-logo">TeachMeGo</div>
      <p className="footer-description">
        Connecting students with expert tutors for better learning outcomes.
      </p>
    </div>
    
    <div className="footer-section">
      <h4>Connect With Us</h4>
      <div className="social-links">
        <a href="https://www.instagram.com/teachmego?igsh=MTVzNjN5ZnRjaHZieg==" 
           target="_blank" 
           rel="noopener noreferrer"
           className="social-link instagram">
          <span className="social-icon">📷</span>
          Instagram
        </a>
        <a href="https://www.facebook.com/teachmego" 
           target="_blank" 
           rel="noopener noreferrer"
           className="social-link facebook">
          <span className="social-icon">👥</span>
          Facebook
        </a>
        <a href="https://www.linkedin.com/company/teachmego/" 
           target="_blank" 
           rel="noopener noreferrer"
           className="social-link linkedin">
          <span className="social-icon">💼</span>
          LinkedIn
        </a>
      </div>
    </div>
    
    <div className="footer-section">
      <h4>Contact</h4>
      <p className="contact-email">
        <a href="mailto:teachmego01@gmail.com">teachmego01@gmail.com</a>
      </p>
    </div>
  </div>
  
  <div className="footer-bottom">
    <p>© 2025 TeachMeGo. All rights reserved.</p>
  </div>
</footer>
    </div>
  );
}

export default LandingPage;
